<template>
  <div class="form-group">
    <p>Búsqueda de Pacientes
    <multiselect
      v-model="selectedTalent"
      :options="searchResults"
      label="nombre"
      track-by="id"
      placeholder="Ingresa el nombre de tu paciente"
      @search-change="searchTalents"
      @select="selectTalent"
      :loading="isLoading"
      :clear-on-select="true"
      :close-on-select="true"
      :allow-empty="false"
    >
    </multiselect>
  </p>
  </div>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect';
var config = require("@/config/api.json");
const API = config.api;

export default {
  name: "SearchTalent",
  components: { Multiselect },
  data() {
    return {
      searchValue: '',
      searchResults: [],
      selectedTalent: null,
      isLoading: false
    };
  },
  props: {
    mainId: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    async searchTalents(query) {
      console.log('Buscando pacientes...', this.mainId, query);
      if (query.trim() === '') {
        this.searchResults = [];
        return;
      }
      this.isLoading = true;
      try {
        const response = await axios.post(`${API}/busqueda-pacientes`, {
          params: {
            searchValue: query,
            personal_medico_id: this.mainId
          }
        });
        this.searchResults = response.data;
      } catch (error) {
        console.error(error);
        this.$emit('notify', 'error', `Error: ${error.message}`);
      } finally {
        this.isLoading = false;
      }
    },
    selectTalent(talent) {
      console.log(talent);
      this.searchResults = [];
      this.$emit('select', talent);
      setTimeout(() => {
        this.selectedTalent = null;
      }, 1000);
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.autocomplete-results {
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.autocomplete-results li {
  padding: 8px;
  cursor: pointer;
}

.autocomplete-results li:hover {
  background-color: #f0f0f0;
}
</style>
